import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ReportContainer from "../ReportContainer";
import Frame from "./Frame";
import FramePageContainer from "./FramePageContainer";
import FramePageContentWrapper from "./FramePageContentWrapper";
import PollingResults from "./PollingResults";
import MenuLayoutList from "./Menu/MenuLayouts/MenuLayoutList";
import AssignMenuLayout from "./Menu/MenuLayouts/AssignMenuLayout";
import config from "../config";
import MenuLayoutEdit from "./Menu/MenuLayouts/MenuLayoutEdit";
import "@progress/kendo-theme-bootstrap";
import Login from "./Login/Login";
import PosRolesList from "./Roles/PosRolesList";
import PosRoleEdit from "./Roles/PosRoleEdit";
import AdminUserList from "./Users/AdminUserList";
import PosUserList from "./Users/PosUserList";
import AdminUserEdit from "./Users/AdminUserEdit";
import PosUserEdit from "./Users/PosUserEdit";
import ArchivedPosUserList from "./Users/ArchivedPosUserList";
import ArchivedAdminUserList from "./Users/ArchivedAdminUserList";

export default function App() {
  let markup;
  if (window.location.pathname.toLowerCase().startsWith("/account/login")) {
    markup = (
      <FramePageContainer>
        <FramePageContentWrapper>
          <h1>You must log in before you can access the site.</h1>
        </FramePageContentWrapper>
      </FramePageContainer>
    );
  } else {
    markup = (
      <Router basename={config.basename}>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Frame insideRouter={true}>
            <Switch>
              <Route path="/reports/:id">
                <ReportContainer />
              </Route>
              <Route path="/forms/pollingresults/">
                <PollingResults />
              </Route>
              <Route exact path="/menulayouts">
                <MenuLayoutList />
              </Route>
              <Route exact path="/menulayouts/new">
                <MenuLayoutEdit />
              </Route>
              <Route exact path="/menulayouts/:id/assignments">
                <AssignMenuLayout />
              </Route>
              <Route exact path="/menulayouts/:id">
                <MenuLayoutEdit />
              </Route>
              <Route exact path="/posroles">
                <PosRolesList />
              </Route>
              <Route exact path="/posroles/new">
                <PosRoleEdit />
              </Route>
              <Route exact path="/posroles/:id">
                <PosRoleEdit />
              </Route>
              <Route exact path="/adminusers">
                <AdminUserList />
              </Route>
              <Route exact path="/posusers">
                <PosUserList />
              </Route>
              <Route exact path="/posusers/archived">
                <ArchivedPosUserList />
              </Route>
              <Route exact path="/posusers/new">
                <PosUserEdit />
              </Route>
              <Route exact path="/posusers/:id">
                <PosUserEdit />
              </Route>
              <Route exact path="/adminusers/archived">
                <ArchivedAdminUserList />
              </Route>
              <Route exact path="/adminusers/new">
                <AdminUserEdit />
              </Route>
              <Route exact path="/adminusers/:id">
                <AdminUserEdit />
              </Route>
              <Route>
                <h1>Not Found</h1>
              </Route>
            </Switch>
          </Frame>
        </Switch>
      </Router>
    );
  }
  return markup;
}
